module.exports = __webpack_public_path__ + "static/media/01.fd33bcc5.webp";